import React from "react";
import { Modal } from "react-bootstrap";

export default function ConfirmDialog({
  open,
  title = "",
  text = "",
  buttons = [],
  onClose,
}) {
  if (!open) return null;

  return (
    <Modal
      show={true}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      contentClassName="p-4"
      onHide={onClose}
    >
      <div className="cqDialogBackdrop">
        <div className="cqDialog" style={{textAlign:'center'}}>
          <h4>{title}</h4>
          {title && <p style={{ whiteSpace: "pre-line" }}>{text}</p>}

          <div
            className="cqDialogActions"
            style={{ widht: "100%", display: "flex", justifyContent: "center" }}
          >
            {buttons.map((btn, idx) => (
              <button
                key={idx}
                style={{ backgroundColor: "#007AC3" }}
                className="btn btn-primary ml-2"
                onClick={() => {
                  btn.action?.();
                  onClose?.();
                }}
              >
                {btn.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </Modal>
  );
}
